import { Modal as BootstrapModal } from 'react-bootstrap'

import { DocumentRecord } from '../../models/Document'

import { Modal } from '../../components/Modal/Modal'

import { useDeleteDocumentMutation } from '../../store/ai/documents'
import { selectAccountId } from '../../store/auth/authSlice'
import { useAppSelector } from '../../store/hooks'

interface DeleteDocumentModalProps {
  show: boolean
  onHide: () => void
  onSuccess?: () => void
  document: DocumentRecord
}

export const DeleteDocumentModal: React.FC<DeleteDocumentModalProps> = ({ show, onHide, onSuccess, document }) => {
  const accountId = useAppSelector(selectAccountId)

  const [triggerDeleteDocument, { isLoading: deleteLoading }] = useDeleteDocumentMutation()

  const handleDelete = async () => {
    try {
      await triggerDeleteDocument({ accountId, documentId: document.id }).unwrap()

      if (onSuccess) {
        onSuccess()
      }
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<BootstrapModal.Title>Delete document</BootstrapModal.Title>}
      headerBodySeparator={true}
      bodyClassName='zocks-pb-0.75'
      body={
        <span>
          By deleting <strong>{document.name}</strong> it's summary will be also deleted, and all unsynchronized insights will be permanently lost.
        </span>
      }
      footerClassName='zocks-pt-0.75 zocks-px-1.5 zocks-pb-1.5'
      showFooterActions={true}
      onFooterPrimaryAction={handleDelete}
      footerPrimaryActionLoading={deleteLoading}
      footerPrimaryActionTitle='Delete'
      footerPrimaryActionButtonVariant='danger'
    />
  )
}
